import {KeyFactSmall} from '@sdox/ui'

import {GenericButton} from '../../../'

import type {XcNwBlock_KeyFactSmallBlockRowType_Fragment} from '@sdox/api'

type BlockKeyFactSmallRowProps = XcNwBlock_KeyFactSmallBlockRowType_Fragment

// TODO this needs a design spec + implementation
export const BlockKeyFactSmallRow = ({items}: BlockKeyFactSmallRowProps) => {
  return (
    <div className={'@container/block'}>
      <div className={'grid grid-cols-1 gap-spacing-48 @block-medium:grid-cols-2 @block-medium:gap-block-medium'}>
        {items.map(({heading, callout, description, image, cta}, idx) => (
          <KeyFactSmall
            key={idx}
            heading={heading ?? ''}
            callout={callout ?? undefined}
            description={description ?? undefined}
            cta={cta ? <GenericButton {...cta} /> : null}
            media={{
              imageProps: {
                src: image?.thumbnailUrl,
                placeholderSrc: image?.thumbnailUrl380w,
                alt: image?.altText ?? heading ?? '',
                width: image?.originalThumbnailDimensions?.width,
                height: image?.originalThumbnailDimensions?.height,
              },
            }}
          />
        ))}
      </div>
    </div>
  )}
